/*
 * General custom scripts
 */
import {
	addBlurEffectOnHover,
	addClassOnScroll,
	menuMobile,
	languageButtonMobile,
	mobileTrigger,
	moveButtonToSidebar,
	searchHeader,
	searchResultsObserver,
	searchIconColor,
	setLangListHeight,
	setupSearchbarHeightWithObserver,
	setSubmenuHeight,
	loadButtons,
	menuDropdownElements,
	setTopbarHeight
} from './front/header';
import { footerMenu } from './front/footer';
import { comments } from './front/comments';
import { slideUpWhenPaginationClicked } from './front/post-query';
import { searchFormTips } from './admin/components/search-form-tips';
import { topBar } from './front/top-bar';
import { abSmartlyButtonClick } from './admin/components/absmartly';

const desktopBreakpoint = window.matchMedia( '(min-width: 1200px)' )
const tabletBreakpoint = window.matchMedia( '(max-width: 1199px)' )
const mobileBreakpoint = window.matchMedia( '(max-width: 767px)' )


topBar()
mobileTrigger()
addClassOnScroll()
searchHeader()
languageButtonMobile()
searchResultsObserver()
searchIconColor()
footerMenu()
setLangListHeight()
setupSearchbarHeightWithObserver()
comments()
slideUpWhenPaginationClicked()

mobileBreakpoint.addEventListener( 'change', loadButtons );
loadButtons( mobileBreakpoint )

tabletBreakpoint.addEventListener( 'change', addBlurEffectOnHover );
addBlurEffectOnHover( tabletBreakpoint )

tabletBreakpoint.addEventListener( 'change', menuMobile );
menuMobile( tabletBreakpoint )

mobileBreakpoint.addEventListener( 'change', moveButtonToSidebar );
moveButtonToSidebar( mobileBreakpoint )

setSubmenuHeight()
window.addEventListener( 'resize', setSubmenuHeight );

setTopbarHeight()
window.addEventListener( 'resize', setTopbarHeight );

desktopBreakpoint.addEventListener( 'change', menuDropdownElements );
menuDropdownElements( desktopBreakpoint )

document.addEventListener( 'DOMContentLoaded', slideUpWhenPaginationClicked );

searchFormTips();
document.addEventListener( 'DOMContentLoaded', abSmartlyButtonClick );







